export default __webpack_public_path__ + "static/media/php_logo.0b219192.png";